module.exports = __webpack_public_path__ + "media/theme/icon__edit--normal-ad582bfc.svg";